import { resolveLink } from '../lib/parse';
import { isPopupLink, openPopup } from '../lib/popup';

/**
 * <a> that understands sheet-style links: full URLs, mailto:, old "Bio" paths, #anchors.
 * A link whose address is recognised in lib/popup.js (currently: any Zeffy donation link)
 * opens the shared in-page pop-up instead of navigating away.
 */
export default function SmartLink({ url, children, className, ...rest }) {
  const { href, external } = resolveLink(url);
  if (!href) return <span className={className}>{children}</span>;
  if (isPopupLink(href)) {
    return (
      <button
        type="button"
        className={`smartlink-btn ${className || ''}`}
        onClick={() => openPopup(href, typeof children === 'string' ? children : undefined)}
        {...rest}
      >
        {children}
      </button>
    );
  }
  return (
    <a className={className} href={href} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})} {...rest}>
      {children}
    </a>
  );
}
